import React from 'react'

import DocumentWrapper from '@/components/DocumentWrapper'
import ScreenWrapper from '@/components/ScreenWrapper'
import Plans from '@/components/Plans'

function AccountEditPlan(): React.ReactElement {
  return (
    <DocumentWrapper title='Common Sense Privacy | Edit Plan'>
      <ScreenWrapper>
        <Plans
          subtitle='To change your plan make a selection below.'
          requiresPaidPlan={false}
          editMode={true}
        />
      </ScreenWrapper>
    </DocumentWrapper>
  )
}

export default React.memo(AccountEditPlan)
